const levels = ['encounter_site','encounter_area','encounter_region']
const SCHISTOSOMIASIS_WEIGHT_THRESHOLD = 15
const FEVER_THRESHOLD_NON_CHILD_INCLUSIVE = 38

function categoryIncluded(selectedCategory, minCategoryNum) {
    if (!selectedCategory || selectedCategory === 'no') {
        return false
    }
    const selectedCategoryNum = parseInt(selectedCategory.slice(-1))
    return selectedCategoryNum >= minCategoryNum
}

export default {
    methods: {
        filterByLocation(responses) {
            const parents = levels.reduce((acc,level) => {
                try {
                    let panel = this.$store.getters['v4/preference/get'](level)
                    let response = panel.responses.find(r => r.selected).value
                    acc.push(response)
                }
                catch (e) {}
                return acc
            }, ['all'])
            const parentMatch = this.$store.state.settings.hierarchy.filter(entry => parents.includes(entry.parent))
            const childList = parentMatch.flatMap(parent => parent.children)
            return responses.filter(r => childList.includes(r.value))
        },

        filterByEncounterPatientOutcome(responses) {
            let result = responses;
            try {
                const worseOutcome = this.$store.getters['v4/panel/getResponse']('encounter_patient_outcome', 'more');
                if (worseOutcome.selected) {
                    result = responses.filter(response => response.value === 'referred');
                }
            }
            catch (e) { console.log(e); }
            return result;
        },

        filterTreatmentsAdministered(responses) {
            // Care category setup
            const careCategoryPanel = this.$store.getters['v4/preference/get']('expanded_care_category')
            const careCategorySelectedValue = careCategoryPanel.responses?.find(r => r.selected)?.value

            // collect other data points
            const trackIsAcuteInjury = this.$store.getters['v4/track/current'].name === 'acute_injury'

            const malariaResponse = this.$store.getters['v4/panel/getResponse']('rdt_status', 'positive')
            const malariaPositiveSelected = !!malariaResponse.selected // convert to bool if necessary

            const temperatureResponse = this.$store.getters['v4/panel/getResponse']('temperature', 'celsius')
            const temperatureAboveFeverThreshhold = parseFloat(temperatureResponse.value) >= FEVER_THRESHOLD_NON_CHILD_INCLUSIVE

            const weightResponse = this.$store.getters['v4/panel/getResponse']('weight')
            const weightAboveThreshold = parseFloat(weightResponse.value) >= SCHISTOSOMIASIS_WEIGHT_THRESHOLD

            // compute disease-based shouldShow conditions
            const shouldShowDehydration = this.$store.getters['v4/mrx/hasRiskOfCondition']('dehydration')
            const shouldShowAbdominalPain = this.$store.getters['v4/mrx/hasRiskOfCondition']('abdominal_pain')
            const shouldShowEyeInfection = this.$store.getters['v4/mrx/hasRiskOfCondition']('eye_infection') && categoryIncluded(careCategorySelectedValue, 0)
            const shouldShowDiarrhea = this.$store.getters['v4/mrx/hasRiskOfCondition']('diarrhea') && categoryIncluded(careCategorySelectedValue, 0)
            const shouldShowSchistosomiasis = this.$store.getters['v4/mrx/hasRiskOfCondition']('schistosomiasis') && categoryIncluded(careCategorySelectedValue, 1)
            const shouldShowPneumonia = this.$store.getters['v4/mrx/hasRiskOfCondition']('respiratory_distress_pneumonia') && categoryIncluded(careCategorySelectedValue, 1)
            const shouldShowReferral = malariaPositiveSelected || shouldShowPneumonia
            const shouldShowFuUnable = shouldShowReferral || shouldShowSchistosomiasis || shouldShowDiarrhea
            const shouldShowFuSymptoms = shouldShowFuUnable || shouldShowEyeInfection

            return responses.filter(({ value }) => {
                switch (value) {
                    case 'treatment0': // "None"
                    case 'treatment1': // "Panadol"
                        return true
                    case 'treatment2': // "Gentian Violet Paint"
                    case 'treatment3': // "Hydrogen Peroxide"
                    case 'treatment4': // "Savlon Solution"
                    case 'treatment5': // "Bandages / Mediplast"
                    case 'treatment6': // "Splint"
                        return trackIsAcuteInjury
                    case 'treatment8': // "Magnesium antacid (MMT)"
                    case 'treatment9': // "Warm Water Bottle"
                        return shouldShowAbdominalPain
                    case 'treatment10': // "Tetracycline 1% ointment..."
                        return shouldShowEyeInfection
                    case 'treatment11': // "Oral rehydration solution..."
                        return shouldShowDehydration || shouldShowDiarrhea
                    case 'treatment12': // "Zinc 20mg tablet..."
                        return shouldShowDiarrhea
                    case 'treatment13': // "Praziquantel 40mg/Kg..."
                        return shouldShowSchistosomiasis && !weightAboveThreshold
                    case 'treatment14': // "Praziquantel, 600mg..."
                        return shouldShowSchistosomiasis && weightAboveThreshold
                    case 'treatment15': // "Amoxicillin, 12-25 mg/Kg..."
                        return shouldShowPneumonia
                    case 'treatment16': // "Paracetamol, 15mg/kg..."
                        return shouldShowPneumonia && temperatureAboveFeverThreshhold
                    case 'treatment17': // "Coartem..."
                        return malariaPositiveSelected
                    case 'treatment18': // "Follow up if unable to take medication, eat or drink"
                        return shouldShowFuUnable
                    case 'treatment19': // "Follow up if symptoms continue or worsen"
                        return shouldShowFuSymptoms
                    case 'treatment20': // "Recommend immediate referral to clinic..."
                        return shouldShowReferral
                    default:
                        return false
                }
            })
        },
    }
}
